import { useEffect, useState } from 'react';
import { api } from '../api';

/**
 * «Google ilə davam et» düyməsi.
 *
 * Düymə YALNIZ server tərəfdə Google konfiqurasiya olunubsa görünür
 * (`GET /api/auth/providers`). Belə olmasa, istifadəçi düyməyə basıb 404
 * alardı — bu, sınıq funksiya təəssüratı yaradır.
 *
 * Naviqasiya `fetch` ilə DEYİL, `location.assign` ilə gedir: OAuth axını
 * brauzerin Google-a keçməsini tələb edir, XHR ilə mümkün deyil.
 */
export function GoogleButton(): React.ReactElement | null {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    api
      .providers()
      .then((p) => {
        if (!cancelled) setEnabled(p.google);
      })
      .catch(() => {
        // Sorğu alınmasa düymə sadəcə görünmür — şifrə ilə giriş işləyir.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!enabled) return null;

  return (
    <>
      <div className="login-sep">
        <span>və ya</span>
      </div>
      <button
        type="button"
        className="btn-google"
        onClick={() => window.location.assign('/api/auth/google')}
      >
        <svg width="17" height="17" viewBox="0 0 48 48" aria-hidden="true">
          <path
            fill="#4285F4"
            d="M45.1 24.5c0-1.6-.1-3.1-.4-4.5H24v8.5h11.8c-.5 2.7-2 5-4.4 6.600v5.5h7.1c4.1-3.8 6.6-9.4 6.6-16.1z"
          />
          <path
            fill="#34A853"
            d="M24 46c6 0 11-2 14.6-5.4l-7.1-5.5c-2 1.3-4.5 2.1-7.5 2.1-5.8 0-10.7-3.9-12.4-9.1H4.3v5.7C7.9 41.1 15.4 46 24 46z"
          />
          <path
            fill="#FBBC05"
            d="M11.6 28.1c-.4-1.3-.7-2.7-.7-4.1s.3-2.8.7-4.1v-5.7H4.3C2.8 17.1 2 20.4 2 24s.8 6.9 2.3 9.8l7.3-5.7z"
          />
          <path
            fill="#EA4335"
            d="M24 10.8c3.3 0 6.2 1.1 8.5 3.3l6.3-6.3C35 4.3 30 2 24 2 15.4 2 7.9 6.9 4.3 14.2l7.3 5.7c1.7-5.2 6.6-9.1 12.4-9.1z"
          />
        </svg>
        Google ilə davam et
      </button>
    </>
  );
}

/**
 * OAuth geri dönüşündə URL-də `?auth_error=` ola bilər. Onu oxuyub
 * istifadəçiyə anlaşılan mətn qaytarır və ünvan sətrini təmizləyir —
 * səhifə yenilənəndə köhnə xəta yenidən görünməsin.
 */
export function useOauthError(): string | null {
  const [msg, setMsg] = useState<string | null>(null);

  useEffect(() => {
    const p = new URLSearchParams(window.location.search);
    const code = p.get('auth_error');
    if (!code) return;

    setMsg(
      {
        cancelled: 'Google ilə giriş yarımçıq qaldı.',
        state: 'Giriş sorğusu təsdiqlənmədi. Yenidən cəhd edin.',
        no_code: 'Google cavabı natamam gəldi. Yenidən cəhd edin.',
        exchange: 'Google hesabınız təsdiqlənmədi. E-poçtunuzun Google-da təsdiqli olduğunu yoxlayın.',
        // Bu e-poçtla artıq şifrəli hesab var. Təhlükəsizlik səbəbindən
        // avtomatik bağlamırıq — bax: apps/panel-api/src/auth/google.ts
        email_taken:
          'Bu e-poçtla artıq hesab var. Şifrənizlə daxil olun — Google hesabınızı sonra hesabın içindən bağlaya bilərsiniz.',
      }[code] ?? 'Google ilə giriş alınmadı.',
    );

    p.delete('auth_error');
    const q = p.toString();
    window.history.replaceState({}, '', window.location.pathname + (q ? `?${q}` : ''));
  }, []);

  return msg;
}
